export class Category {
  readonly #value: string;

  private constructor(value: string) {
    this.#value = value;
  }

  static of(value: Category | string): Category {
    if (value instanceof Category) {
      return value;
    }
    return new Category(value);
  }

  get value(): string {
    return this.#value;
  }
}
